'use strict';

var inheritArray = require('inherit-array');

angular.module('dekky.pagination', [])
.provider('pagination', function() {
	var defaultConfig = {
		itemsOnPage: 10,
		type: 'endless',
		next: null
	};

	return {
		setItemsOnPage: function(count) {
			defaultConfig.itemsOnPage = count;
		},
		$get: function($q) {
			function collectionFactory(name, config) {
				var factory = inheritArray(Collection);
				return factory(name, config);
			}

			function Collection(name, config) {
				this.config = angular.merge({}, defaultConfig, config);
				this.name = name;
				this.progress = false;
				this.current_page = 0;
			}

			Collection.prototype.next = function() {
				var that = this;
				if (typeof(that.config.next) == 'function') {
					that.progress = true;

					return that.config.next(++that.current_page, that.config.itemsOnPage)
						.then(function(response){
							response.forEach(function(item) {
								that.push(item);
							});
							that.progress = false;

							return $q.when(response);
						})
						.catch(function(response) {
							that.current_page--;
							that.progress = false;

							return $q.reject(response);
						});
				}
			};

			Collection.prototype.clear = function() {
				this.length = 0;
				this.current_page = 0;
				this.next();
			};

			Collection.prototype.changeItemsOnPage = function(itemsOnPage) {
				this.config.itemsOnPage = itemsOnPage;
				this.clear();
			};

			return collectionFactory;
		}
	}
});